import { Component, Inject } from '@angular/core';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';
import { TuiDialog } from '@taiga-ui/cdk';

@Component({
  selector: 'df-tactic-settings-close-alert',
  templateUrl: './tactic-settings-close-alert.component.html',
  styleUrls: ['./tactic-settings-close-alert.component.scss'],
})
export class TacticSettingsCloseAlertComponent {
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    readonly context: TuiDialog<TacticSettingsCloseAlertComponent, boolean>,
  ) {}

  confirmExit(): void {
    this.context.completeWith(true);
  }

  cancel(): void {
    this.context.completeWith(false);
  }
}
